(function ($, Promise) {

    var jqxr;
    var monitors = [];

    // Constructor
    function VICC(lang) {

      //  Make sure that websocket is supported by browser. If not, show message.
      this.supportsWebSockets = 'WebSocket' in window || 'MozWebSocket' in window;
      this.language = lang;

      // Disable links to the same page (to prevent the reload of the current page)
      // https://github.com/barbajs/barba/issues/34#issuecomment-712874130
      $(document).on('click', 'a[href]', $.proxy(function (e) {

        if ($(e.currentTarget).is(".prevent-default")) {
          e.preventDefault();
          e.stopPropagation();
        } else if (e.currentTarget.href.replace(e.currentTarget.hash, "") === window.location.href.replace(window.location.hash, "")) {
          // Same page, using anchor
          e.preventDefault();
          e.stopPropagation();

          if (($(e.currentTarget).parent().is("#header") || $(e.currentTarget).parents().is("#mobile-menu")) && e.currentTarget.href.includes("visualize") && $("#visualize-share").is(".shown")) {
            // Close the drawer when clicking in menu
            app.components.visualize.share.closeShareDrawer();
          } else if (e.currentTarget.hash) {
            history.pushState({}, null, e.currentTarget.href);

            if ($(e.currentTarget).parents("#visualize-share").length) {
              VICC.prototype.scrollTo($(e.currentTarget.hash), "#visualize-share #visualize-share-inner", 20);
            } else {
              VICC.prototype.scrollTo($(e.currentTarget.hash), "html, body", 20);
            }
          }
        } else if (!$(e.currentTarget).attr("href").includes('visualize') || !$(e.currentTarget).attr("href").includes("what-now")) {
          // Reset
          $("#header a[href*='what-now']:not(.language-switcher), #mobile-menu a[href*='what-now']:not(.language-switcher)").removeClass("prevent-default disable-barba");
        }

      }, this));

      // Toggle mobile menu
      $("#header .menu-toggle").on("click", function (e) {
        $(this).toggleClass("is-active", !$(this).is(".is-active"));
        $("#mobile-menu").toggleClass("shown", $(this).is(".is-active"));
      });

      // Close menu after click
      $("#mobile-menu a:not(.disable-barba)").on("click", function (e) {
        $("#header .menu-toggle.is-active").trigger("click");
      });

      this.googleMapReady = false;
      this.currentComponent = false;

      // Init main page component
      this.components = {
        "anim": new Anim(),
        "home": new VICCHome(),
        "what-now": new VICCWhatNow(),
        "about": new VICCAbout(),
        "visualize": new VICCVisualize(),
        "share": new VICCShare(),
      };

      // Local function to be called to attach components
      function attach(data) {

        // Anim needs to be on every page
        Anim.prototype.attach();

        // Update active URL
        $("#header a[href]").removeClass("active");
        $("#header a[href='" + window.location.pathname + "']").addClass("active");

        var pathName = window.location.pathname.replace(/\/$/, "");
        var frontUrl = [
          "", "/", "/en", "/fr", "/en/home", "/fr/home"
        ];
        if ($.inArray(pathName, frontUrl) !== -1) {
          // We are on the front page
          $("body").removeClass("not-frontpage").addClass("frontpage");
        } else {
          // We're not
          $("body").removeClass("frontpage").addClass("not-frontpage");
        }

        // Trigger component attach
        if (app.components[data.next.namespace]) {
          app.currentComponent = app.components[data.next.namespace];
          app.components[data.next.namespace].attach(data.next.container)
        }

        // Update language link in header
        var contentPath = data.next.url.path.replace(/^(\/fr\/|\/en\/)/, "/");
        if (["thisclimatedoesnotexist.com", "ceclimatnexistepas.com"].includes(window.location.hostname)) {
          $(".language-switcher").attr("href", ((app.language == "fr" ? "//thisclimatedoesnotexist.com" : "//ceclimatnexistepas.com") + contentPath));
        } else {
          $(".language-switcher").attr("href", ("/" + (app.language == "fr" ? "en" : "fr") + contentPath));
        }

        // Show popup on first visit
        if (!Cookies.get('vicc_visited') && data.next.namespace != "privacy-policy") {
          $("body").addClass("disable-scroll");
          $("#legal-popup").removeClass("hidden");

          if (navigator.cookieEnabled) {
            $("#legal-popup .cta-button").off("click").on("click", function () {
              Cookies.set('vicc_visited', true, {expires: 365, path: '/'});
              $("body").removeClass("disable-scroll");
              $("#legal-popup").addClass("hidden");

              $("#legal-popup .hide-cookie-disabled").removeClass("hidden");
              $("#legal-popup .cookie-disabled").addClass("hidden");
            });
          } else {
            // Show message to tell user to active cookies
            $("#legal-popup .hide-cookie-disabled").addClass("hidden");
            $("#legal-popup .cookie-disabled").removeClass("hidden");
          }
        } else {
          // user already accepted terms or is ready privacy policy
          $("body").removeClass("disable-scroll");
          $("#legal-popup").addClass("hidden");
        }
      }

      // Local function to be called to detrach components
      function dettach(data) {

        // Anim needs to be on every page
        Anim.prototype.dettach();

        // Trigger component dettach
        if (app.components[data.current.namespace]) {
          app.components[data.current.namespace].dettach(data.current.container);
        }
      }

      barba.init({
        // debug: true,
        prefetchIgnore: true,
        prevent: function (e) {
          if (e.el.classList && e.el.classList.contains('disable-barba')) {
            console.log("Prevent Barba")
            return true;
          }
          return false;
        },
        transitions: [{
          leave: function (data) {
            // Anime out
            // create your stunning leave animation here
            return gsap.to(data.current.container, {
              duration: .25,
              alpha: 0,
              onComplete: function (data) {
                // Loading screen is hiding everything, time to remove old content!
                window.scrollTo(0, 0);
                $(data.current.container).css("position", "absolute");
                $(data.current.container).empty();
              },
              onCompleteParams: [data]
            })
          },
          enter: function (data) {
            // Scroll to top
            gsap.set('html, body', {scrollTop: 0});

            // Anime in
            // create your stunning enter animation here
            return gsap.fromTo(data.next.container, {alpha: 0}, {duration: .25, alpha: 1})
          },
          beforeLeave: dettach,
          once: attach,
          beforeEnter: attach,
          after: function (data) {

            // Call resize on components to make sure that DOM is ready on resize
            if (app.components[data.next.namespace] && typeof app.components[data.next.namespace].resize == "function") {
              app.components[data.next.namespace].resize()
            }

            // Register pageview on analytics
            if (typeof gtag != "undefined") {
              $.each(window.gtag_ids.split(","), function (i, gtag_id) {
                // console.log(gtag_id, data.next.namespace)
                gtag('config', gtag_id, {
                  'page_title': data.next.namespace,
                  'page_path': window.location.pathname,
                  'anonymize_ip': true
                });
              })
            }
          }
        }]
      })
    }

    /*
     * Scroll to with animation.
     */
    VICC.prototype.scrollTo = function (targetEl, scrollingEl = "html, body", offset = 0) {
      var headerHeight = ($("#header").outerHeight() - 1) + offset;

      if ($(targetEl).length > 0) {
        if (scrollingEl != "html, body") {
          gsap.to(scrollingEl, 0.5, {
            scrollTop: $(targetEl).position().top - offset,
          });
        } else {
          gsap.to(scrollingEl, 0.5, {
            scrollTop: $(targetEl).offset().top - headerHeight,
          });
        }
      }
    }

    window.VICCInitMap = function () {
      while (typeof app == "undefined" || typeof app.currentComponent == "undefined") {
        setTimeout(VICCInitMap, 250)
        return;
      }
      app.googleMapReady = true;

      if (typeof app.currentComponent != "undefined" && typeof app.currentComponent.googleMapReady == "function") {
        app.currentComponent.googleMapReady();
      }
    }

    // Expose VICC
    window.VICC = VICC;
  }
)
(jQuery, Promise);
